var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-text",
    _vm._b(
      {
        ref: "input",
        staticClass: "f-text",
        class: { classes: _vm.classes },
        on: { input: _vm.input, change: _vm.change },
      },
      "w-text",
      {
        value: _vm.value,
        label: _vm.label,
        required: _vm.required,
        validate: _vm.validate,
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }